import React from 'react';
import { Box, Button } from '@mui/material';

const ProjectViewToggle = ({ viewMode, onChange }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1, }}>
      <Button
        onClick={() => onChange('card')}
        sx={{
          background: viewMode === 'card' ? '#F5F8FF' : '#fff',
          borderRadius: '8px',
          color: '#1A1F36',
          fontSize: '16px',
          textTransform: 'capitalize',
          width: '34px',
          minWidth: '34px',
          height: '34px',
          border: '1px solid #E5E8EB',
        }}
      >
        <img
          src="./assets/images/app-activity/projects/icons/project-box-icon.svg"
          className="img-fluid"
          alt="project box icon"
        />
      </Button>
      <Button
        onClick={() => onChange('table')}
        sx={{
          background: viewMode === 'table' ? '#F5F8FF' : '#fff',
          borderRadius: '8px',
          color: '#1A1F36',
          fontSize: '16px',
          textTransform: 'capitalize',
          width: '34px',
          minWidth: '34px',
          height: '34px',
          border: '1px solid #E5E8EB',
        }}
      >
        <img
          src="./assets/images/app-activity/projects/icons/project-table-icon.svg"
          className="img-fluid"
          alt="project table icon"
        />
      </Button>
    </Box>
  );
};

export default ProjectViewToggle;
